import { useRef } from 'react';
import CardRenderer from './CardRenderer';
import './DashboardCard.css';

const DraggableCard = ({ card, dashboardData, isEditMode, onToggle, group }) => {
  const cardRef = useRef(null);

  return (
    <div 
      ref={cardRef}
      className={`draggable-card ${isEditMode ? 'edit-mode' : ''} ${!card.enabled ? 'disabled' : ''}`}
      style={{ width: '100%', height: '100%' }}
    >
      {/* 비활성화 여부와 관계없이 원래 카드 표시 */}
      <CardRenderer
        cardType={card.type}
        card={card}
        dashboardData={dashboardData}
        isEditMode={isEditMode}
        onToggle={onToggle}
      />
      
      {/* 편집 모드에서만 오버레이 표시 */}
      {isEditMode && (
        <div className="card-edit-overlay">
          <button
            className="toggle-card-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (onToggle) {
                onToggle(card.id);
              }
            }}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {card.enabled ? '비활성화' : '활성화'}
          </button>
        </div>
      )}
    </div>
  );
};

export default DraggableCard;

